// ========== [DISPARA ANIMAÇÃO] ==========
jQuery(document).ready(function ($) {
  $(document).on("scroll", (e) => {
    const estatistica = $(".home-estatisticas")[0];
    if (estatistica) {
      const d_est = estatistica.offsetTop;
      const d_pag =
        window.pageYOffset + window.innerHeight - estatistica.offsetHeight - 80;
      // -88 - 80
      let animou = false;
      if (!animou) {
        if (d_est - d_pag < 0) {
          $(".count-1, .count-2, .count-3").addClass("animar-contador");
          animou = true;
        }
      }
    }
  });
});
